import { createAsyncThunk } from "@reduxjs/toolkit";
import type { RootState } from "../../store";
import {
  toggleFavorite as toggleFavoriteService,
  getFavorites as getFavoritesService,
  getFavoriteIds as getFavoriteIdsService,
  getFavoriteTabs as getFavoriteTabsService,
  bulkDeleteFavorites as bulkDeleteFavoritesService,
} from "./favorite.service";
import {
  ToggleFavoriteRequest,
  ToggleFavoriteResponse,
  FavoritesResponse,
  FavoriteIdsResponse,
  FavoriteTabsResponse,
  GetFavoritesRequest,
  BulkDeleteFavoritesRequest,
  BulkDeleteFavoritesResponse,
} from "./favorite.types";
import { handleApiError } from "@/app/utils/handleApiError";

export const toggleFavorite = createAsyncThunk<
  ToggleFavoriteResponse,
  ToggleFavoriteRequest,
  { rejectValue: string }
>("favorite/toggleFavorite", async ({ productId, variantId }, { rejectWithValue }) => {
  try {
    const response = await toggleFavoriteService(productId, variantId);
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const getFavorites = createAsyncThunk<
  FavoritesResponse,
  GetFavoritesRequest | undefined,
  { rejectValue: string }
>("favorite/getFavorites", async (params, { rejectWithValue }) => {
  try {
    const response = await getFavoritesService(params);
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const getFavoriteIds = createAsyncThunk<
  FavoriteIdsResponse,
  void,
  { rejectValue: string; state: RootState }
>(
  "favorite/getFavoriteIds",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getFavoriteIdsService();
      return response;
    } catch (error) {
      return rejectWithValue(handleApiError(error));
    }
  },
  {
    // AppEffects mount'ta, FavoritesTab kendi mount'unda çağırıyor — liste bir
    // kez geldiyse tekrar çekme. Logout'ta clearFavorites idsStatus'ü "idle"a
    // döndürdüğü için sonraki girişte yeniden çekilir.
    condition: (_, { getState }) => {
      const { idsStatus } = getState().favorite;
      return idsStatus !== "loading" && idsStatus !== "success";
    },
  },
);

export const getFavoriteTabs = createAsyncThunk<
  FavoriteTabsResponse,
  void,
  { rejectValue: string }
>("favorite/getFavoriteTabs", async (_, { rejectWithValue }) => {
  try {
    const response = await getFavoriteTabsService();
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const bulkDeleteFavorites = createAsyncThunk<
  BulkDeleteFavoritesResponse,
  BulkDeleteFavoritesRequest,
  { rejectValue: string }
>("favorite/bulkDeleteFavorites", async (data, { rejectWithValue }) => {
  try {
    const response = await bulkDeleteFavoritesService(data);
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});